import { formatTextNumber } from "../../../utils/helpers";

export function DiscountAmount(props) {
    const { value } = props;

    return (
        <>
            -{formatTextNumber(value)} đ
        </>
    );
}